// eslint-disable-next-line func-names
(function () {
    function $extender(obj) {
        function isEmpty() {
            return Object.keys(obj).length === 0;
        }
        function has(key) {
            return Object.keys(obj).indexOf(key) !== -1;
        }
        function hasOnly(key) {
            return Object.keys(obj).length === 1 && Object.keys(obj).indexOf(key) !== -1;
        }
        function trim(keys) {
            const newObj = { ...obj };
            if (typeof keys === 'string') {
                delete newObj[keys];
            } else if (Array.isArray(keys)) {
                keys.forEach((key) => {
                    delete newObj[key];
                });
            }
            return newObj;
        }
        const { length } = Object.keys(obj);
        function toArray() {
            const keys = Object.keys(obj);
            return keys.map((key) => obj[key]);
        }
        return {
            isEmpty,
            has,
            length,
            hasOnly,
            trim,
            toArray
        };
    }

    // eslint-disable-next-line no-extend-native
    Object.defineProperty(Object.prototype, 'extensions', {
        set() {},
        get() {
            return $extender(this);
        }
    });
}());